module.exports = __webpack_public_path__ + "92af96ea2627f5e0bf703a4fc34f5d8b.png";